import React from 'react';
import { Cell, Row } from './EffectDropdownTableRow.styles';
import { IToggleState, Question } from '../../../../../../../../services/reports';
import TrendBox from '../../../../../TrendBox/TrendBox';
import ColorBar from '../../ColorBar/ColorBar';

interface EffectDropdownTableRowProps {
  data: Question;
  togglersState: IToggleState;
}

const EffectDropdownTableRow: React.FC<EffectDropdownTableRowProps> = ({ data, togglersState }) => {
  const { text, average_value, change, historical_value, num_idk } = data;
  const isNegative = Number(change) < 0;

  return (
    <>
      <Row>
        <Cell>{text}</Cell>
        <Cell>{average_value === null ? '-' : average_value.toFixed(1)}</Cell>
        {historical_value ? (
          <TrendBox change={change} isNegative={isNegative} hasBorder={true} />
        ) : (
          <div />
        )}
        <Cell>
          <ColorBar data={data} togglersState={togglersState} slim />
        </Cell>
        <Cell>{num_idk ? num_idk : '-'}</Cell>
      </Row>
    </>
  );
};

export default EffectDropdownTableRow;
